import { render } from "./StockReport.vue?vue&type=template&id=41df6c3e&ts=true"
import script from "./StockReport.vue?vue&type=script&lang=ts"
export * from "./StockReport.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__